import { render } from "./FireworksComponent.vue?vue&type=template&id=221d5290&scoped=true"
import script from "./FireworksComponent.vue?vue&type=script&lang=js"
export * from "./FireworksComponent.vue?vue&type=script&lang=js"

import "./FireworksComponent.vue?vue&type=style&index=0&id=221d5290&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221d5290"]])

export default __exports__